import { ISelectItem } from '@lla-platform/core/core-ui'

export enum CallServiceCategory {
  Unknown = 'Unknown',
  OilChange = 'OilChange',
  Brakes = 'Brakes',
  Tires = 'Tires',
  Alignment = 'Alignment',
  Suspension = 'Suspension',
  Transmission = 'Transmission',
  EngineDiagnostic = 'EngineDiagnostic',
  Electrical = 'Electrical',
  AcHeating = 'AcHeating',
  Battery = 'Battery',
  Inspection = 'Inspection',
  ScheduledMaintenance = 'ScheduledMaintenance',
  BodyWork = 'BodyWork',
  Other = 'Other'
}

export const CallServiceCategoryToLabel: Record<string, string> = {
  Unknown: 'Unknown',
  OilChange: 'Oil change',
  Brakes: 'Brakes',
  Tires: 'Tires',
  Alignment: 'Alignment',
  Suspension: 'Suspension',
  Transmission: 'Transmission',
  EngineDiagnostic: 'Engine diagnostic',
  Electrical: 'Electrical',
  AcHeating: 'AC & heating',
  Battery: 'Battery',
  Inspection: 'Inspection',
  ScheduledMaintenance: 'Scheduled maintenance',
  BodyWork: 'Body work',
  Other: 'Other'
}

export const CallServiceCategoryItems: ISelectItem[] = Object.values(CallServiceCategory).map(
  (value) => ({
    label: CallServiceCategoryToLabel[value],
    value
  })
)
